'use strict';

var AsciiText = require('./AsciiText');
var CmdBuf = require('./CmdBuf');
var Log = require('../../../../log/Log');
var log = Log.channel('CmdSocket');
var driverLog = Log.channel('CmdSocket', 'driver');
var SocketWrapper = require('./SocketWrapper');
var StateMachine = require('../../state-machine.min');

var telnetOptions = {
    '\x00': 'binary transmission',
    '\x01': 'echo',
    '\x02': 'reconnection',
    '\x03': 'suppress go ahead',
    '\x04': 'approx msg size negotiation',
    '\x05': 'status',
    '\x06': 'timing mark',
    '\x07': 'remote controlled trans and echo',
    '\x08': 'output line width',
    '\x09': 'output page size',
    '\x0a': 'output carraige return',
    '\x0b': 'output horizontal tab stops',
    '\x0c': 'output horizontal tab disposition',
    '\x0d': 'output formfeed disposition',
    '\x0e': 'output vertical tab stops',
    '\x0f': 'output vertical tab disposition',
    '\x10': 'output linefeed disposition',
    '\x11': 'extended ascii',
    '\x12': 'logout',
    '\x13': 'byte macro',
    '\x14': 'data entry terminal',
    '\x15': 'SUPDUP',
    '\x16': 'SUPDUP output',
    '\x17': 'send location',
    '\x18': 'terminal type',
    '\x19': 'end of record',
    '\x1a': 'TACACS user identification',
    '\x1b': 'output marking',
    '\x1c': 'terminal location number',
    '\x1d': 'telnet 3270 regime',
    '\x1e': 'X.3 PAD',
    '\x1f': 'negotiate about window size',
    '\x20': 'terminal speed',
    '\x21': 'remote flow control',
    '\x22': 'linemode',
    '\x23': 'x display location',
    '\x24': 'environment option',
    '\x25': 'authentication option',
    '\x26': 'encryption option',
    '\x27': 'new environment option',
    '\x28': 'TN3270E',
    '\x29': 'XAUTH',
    '\x2a': 'CHARSET',
    '\x2b': 'telnet remote serial port',
    '\x2c': 'com port control option',
    '\x2d': 'telnet suppress local echo',
    '\x2e': 'telnet start TLS',
    '\x2f': 'KERMIT',
    '\x30': 'SEND-URL',
    '\x31': 'FORWARD_X',
    '\x8a': 'TELOPT PRAGMA LOGON',
    '\x8b': 'TELOPT SSPI LOGON',
    '\x8c': 'TELOPT PRAGMA HEARTBEAT',
    '\xff': 'extended options list',
};

function CmdSocket(props) {
    var prop;

    this.props = {};

    for (prop in CmdSocket.prototype.props) {
        if (!CmdSocket.prototype.props.hasOwnProperty(prop)) continue;
        if (props.hasOwnProperty(prop)) {
            this.props[prop] = props[prop];
        } else {
            this.props[prop] = CmdSocket.prototype.props[prop];
        }
    }

    if (!this.props.hasOwnProperty('password') || this.props.password === undefined) {
        this.props.password = '';
    }

    this.cmdBuf = new CmdBuf(this.props.receiveTerminators,
        this.props.unterminatedRegExp, this.props.extractCommand,
        this.props.negotiateTelnet);
    this.cmdBuf.allowEmptyCommands = this.props.allowEmptyCommands;
    this.socket = null;
    this.processingCommands = false;
    this.sendQueue = [];
    this.respQueue = [];
    this.syncTimeout = null;
    this.suspendSyncTimeout = null;
    this.syncTimeoutMsOverrides = {};
    this.retryCallbacks = {};
    this.sendRetries = 0;
    this.destroyed = false;

    this.client = {};
    this.client.onConnectResult = null;
    this.client.onReceiveCommand = null;
    this.client.onConnectionLost = null;
    this.client.onSendSync = null;

    this.con = {};

    for (prop in CmdSocket.prototype.con) {
        if (!CmdSocket.prototype.con.hasOwnProperty(prop)) continue;
        this.con[prop] = CmdSocket.prototype.con[prop];
    }

    // device connection state
    this.con.doAuto = true;
    this.con.methods = [];
    this.con.methodIndex = -1;
    this.con.method = null;
    this.con.connected = false;
    this.con.authenticated = false;
    this.con.portIndex = -1;
    this.con.port = null;
    this.con.verifyTimeout = null;
    this.con.userPromptTimeout = null;
    this.con.passwordPromptTimeout = null;
    this.con.loginVerifyTimeout = null;
    this.con.fsm = StateMachine.create({
        events: [
            { name: 'goToStart',             from: 'none',                         to: 'start' },
            { name: 'tryNextMethod',         from: 'start',                        to: 'tryingNextMethod' },
            { name: 'tryNextPort',           from: [ 'tryingNextMethod',
                                                     'connectingPort',
                                                     'verifyingConnection',
                                                     'lookingForUserPrompt',
                                                     'sendingUser',
                                                     'lookingForPasswordPrompt',
                                                     'sendingPassword',
                                                     'rejectingLogin' ],           to: 'tryingNextPort' },
            { name: 'fail',                  from: 'tryingNextMethod',             to: 'failed' },
            { name: 'connectPort',           from: 'tryingNextPort',               to: 'connectingPort' },
            { name: 'tryNextMethod',         from: 'tryingNextPort',               to: 'tryingNextMethod' },
            { name: 'verifyConnection',      from: 'connectingPort',               to: 'verifyingConnection' },
            { name: 'lookForUserPrompt',     from: 'verifyingConnection',          to: 'lookingForUserPrompt' },
            { name: 'sendUser',              from: [ 'verifyingConnection',
                                                     'lookingForUserPrompt' ],     to: 'sendingUser' },
            { name: 'skipLogin',             from: [ 'lookingForUserPrompt',
                                                     'lookingForPasswordPrompt' ], to: 'skippingLogin' },
            { name: 'lookForPasswordPrompt', from: [ 'verifyingConnection',
                                                     'sendingUser'],               to: 'lookingForPasswordPrompt' },
            { name: 'sendPassword',          from: [ 'verifyingConnection',
                                                     'sendingUser',
                                                     'lookingForPasswordPrompt' ], to: 'sendingPassword' },
            { name: 'skipLogin',             from: [ 'lookingForUserPrompt',
                                                     'lookingForPasswordPrompt' ], to: 'skippingLogin' },
            { name: 'acceptLogin',           from: 'sendingPassword',              to: 'acceptingLogin' },
            { name: 'rejectLogin',           from: 'sendingPassword',              to: 'rejectingLogin' },
            { name: 'finish',                from: [ 'verifyingConnection',
                                                     'skippingLogin',
                                                     'acceptingLogin' ],           to: 'finished' },
        ],
        callbacks: {
            ongoToStart: this.con.onGoToStart.bind(this),
            ontryNextMethod: this.con.onTryNextMethod.bind(this),
            ontryNextPort: this.con.onTryNextPort.bind(this),
            onfail: this.con.onFail.bind(this),
            onconnectPort: this.con.onConnectPort.bind(this),
            onverifyConnection: this.con.onVerifyConnection.bind(this),
            onlookForUserPrompt: this.con.onLookForUserPrompt.bind(this),
            onsendUser: this.con.onSendUser.bind(this),
            onlookForPasswordPrompt: this.con.onLookForPasswordPrompt.bind(this),
            onsendPassword: this.con.onSendPassword.bind(this),
            onfinish: this.con.onFinish.bind(this),
            onskipLogin: this.con.onSkipLogin.bind(this),
            onrejectLogin: this.con.onRejectLogin.bind(this),
            onacceptLogin: this.con.onAcceptLogin.bind(this)
        }
    });
}

// keep device connection states and methods in their own namespace
CmdSocket.prototype.con = {};

// properties that can be set on the socket in its constructor
CmdSocket.prototype.props = {};
CmdSocket.prototype.props.allowEmptyCommands = false;
CmdSocket.prototype.props.extractCommand = null;
CmdSocket.prototype.props.ipAddress = 'uninitialized';
CmdSocket.prototype.props.isAsync = true;
CmdSocket.prototype.props.isBinary = false;
CmdSocket.prototype.props.name = 'Leroy Jenkins';
CmdSocket.prototype.props.negotiateTelnet = false;
CmdSocket.prototype.props.password = null;
CmdSocket.prototype.props.ports = null;
CmdSocket.prototype.props.receiveTerminators = [ '\r', '\n' ];
CmdSocket.prototype.props.rejectAsync = true;
CmdSocket.prototype.props.sendTerminator = '\r';
CmdSocket.prototype.props.syncTimeoutMs = 0;
CmdSocket.prototype.props.unterminatedRegExp = null;
CmdSocket.prototype.props.username = null;

// Function to clear all synchronous commands from the queue (as long as they
// haven't been sent yet).

CmdSocket.prototype.clearSync = function(param) {
    driverLog.debug(this + ': emptying send and resp queues');
    var lengthsEqual = this.sendQueue.length === this.respQueue.length;

    this.sendQueue.length = 0;

    if (lengthsEqual) {
        this.respQueue.length = 0;
    } else {
        this.respQueue.splice(1);
    }
};

CmdSocket.prototype.closeSocket = function() {
    if (this.socket !== null &&
        (this.socket.state === 'connected' ||
        this.socket.state === 'connecting')) {
        this.socket.disconnect();
        this.socket = null;
    }
};

CmdSocket.prototype.con.broadcastConnectResult = function(result) {
    if (result.connected) {
        if (result.authenticated) {
            if (result.state === 'succeeded') {
                log.debug(this + ': successfully connected to port ' + result.port);
            } else {
                log.debug(this + ': unable to connect, verification failed');
            }
        } else {
            log.debug(this + ': unable to connect, authentication failed');
        }
    } else {
        log.debug(this + ': unable to connect, connection failed');
    }

    if (this.client.onConnectResult) {
        this.client.onConnectResult(result);
    }
};

CmdSocket.prototype.con.cleanUp = function() {
    window.clearTimeout(this.con.verifyTimeout);
    window.clearTimeout(this.con.userPromptTimeout);
    window.clearTimeout(this.con.passwordPromptTimeout);
    window.clearTimeout(this.con.loginVerifyTimeout);
    this.closeSocket();
};

CmdSocket.prototype.con.doTransitionAfterVerify = function() {
    if (this.con.port.hasOwnProperty('userPrompt') &&
        this.con.port.userPrompt !== null) {
        this.con.fsm.lookForUserPrompt();
    } else if (this.con.port.hasOwnProperty('userSend') &&
        this.con.port.userSend !== null) {
        this.con.fsm.sendUser();
    } else if (this.con.port.hasOwnProperty('passwordPrompt') &&
        this.con.port.passwordPrompt !== null) {
        this.con.fsm.lookForPasswordPrompt();
    } else if (this.con.port.hasOwnProperty('passwordSend') &&
        this.con.port.passwordSend !== null) {
        this.con.fsm.sendPassword();
    } else {
        this.con.fsm.finish();
    }
};

CmdSocket.prototype.con.onAcceptLogin = function() {
    log.debug(this + ': onAcceptLogin');
    this.con.fsm.finish();
};

CmdSocket.prototype.con.onConnectError = function(msg) {
    log.debug(this + ': onConnectError: ' + msg);

    // If we get this message from an SSH connection, it means we connected but
    // couldn't authenticate. We set connected to true so that the result will
    // be interpreted as an authentication failure as opposed to a connection
    // failure.

    if (this.con.port.ssh && msg === 'Exhausted available authentication methods') {
        this.con.connected = true;
    }

    if (!this.destroyed) this.con.fsm.tryNextPort();
};

CmdSocket.prototype.con.onConnectPort = function() {
    log.debug(this + ': onConnectPort: port number = ' + this.con.port.port);

    this.cmdBuf.clear();
    this.closeSocket();
    this.socket = new SocketWrapper();

    if (this.con.port.ssh) {
        this.socket.connectSsh(this.props.ipAddress, this.con.port.port,
            this.con.user, this.con.password,
            this.con.onConnectSuccess.bind(this),
            this.con.onConnectError.bind(this),
            this.onReceive.bind(this));
    } else {
        this.socket.connectPlain(this.props.ipAddress, this.con.port.port,
            this.con.onConnectSuccess.bind(this),
            this.con.onConnectError.bind(this),
            this.onReceive.bind(this));
    }
};

CmdSocket.prototype.con.onConnectSuccess = function() {
    log.debug(this + ': onConnectSuccess');
    this.con.fsm.verifyConnection();
};

CmdSocket.prototype.con.onFail = function() {
    log.debug(this + ': onFail');
    this.con.cleanUp.call(this);

    this.con.broadcastConnectResult.call(this, {
        state: 'failed',
        connected: this.con.connected,
        authenticated: this.con.authenticated
    });
};

CmdSocket.prototype.con.onFinish = function() {
    log.debug(this + ': onFinish');

    this.con.authenticated = true;

    var result = {
        state: 'succeeded',
        port: this.con.port.port,
        connected: this.con.connected,
        authenticated: this.con.authenticated
    };

    if (this.con.password !== null) {
        result.password = this.con.password;
    }

    this.socket.setConnectionLostCallback(this.onConnectionLost.bind(this));
    this.con.broadcastConnectResult.call(this, result);
};

CmdSocket.prototype.con.onGoToStart = function() {
    log.debug(this + ': onGoToStart');

    this.con.methods = [];
    this.con.methodIndex = -1;
    this.con.connected = false;
    this.con.authenticated = false;

    if (this.props.password) {
        this.con.methods.push('password');
    }

    if (this.con.doAuto) {
        this.con.methods.push('auto');
    }

    this.con.fsm.tryNextMethod();
};

CmdSocket.prototype.con.onLoginVerifyTimeoutExpired = function() {
    log.debug(this + ': onLoginVerifyTimeoutExpired');
    this.con.fsm.tryNextPort();
};

CmdSocket.prototype.con.onLookForPasswordPrompt = function() {
    log.debug(this + ': onLookForPasswordPrompt');
    this.con.passwordPromptTimeout = window.setTimeout(
        this.con.onPasswordPromptTimeoutExpired.bind(this),
        this.con.port.passwordPromptTimeoutMs);
};

CmdSocket.prototype.con.onLookForUserPrompt = function() {
    log.debug(this + ': onLookForUserPrompt');
    this.con.userPromptTimeout = window.setTimeout(
        this.con.onUserPromptTimeoutExpired.bind(this),
        this.con.port.userPromptTimeoutMs);
};

CmdSocket.prototype.con.onPasswordPromptTimeoutExpired = function() {
    log.debug(this + ': onPasswordPromptTimeoutExpired');
    this.con.fsm.tryNextPort();
};

CmdSocket.prototype.con.onReceiveInLookingForPasswordPrompt = function(cmd) {
    var match;

    if (this.con.port.hasOwnProperty('loginSkip') &&
        this.con.port.loginSkip !== null) {
        match = this.con.port.loginSkip.exec(cmd);

        if (match !== null) {
            window.clearTimeout(this.con.passwordPromptTimeout);
            this.con.fsm.skipLogin();
            return;
        }
    }

    match = this.con.port.passwordPrompt.exec(cmd);

    if (match !== null) {
        window.clearTimeout(this.con.passwordPromptTimeout);
        this.con.fsm.sendPassword();
    }
};

CmdSocket.prototype.con.onReceiveInLookingForUserPrompt = function(cmd) {
    var match;

    if (this.con.port.hasOwnProperty('loginSkip') &&
        this.con.port.loginSkip !== null) {
        match = this.con.port.loginSkip.exec(cmd);

        if (match !== null) {
            window.clearTimeout(this.con.userPromptTimeout);
            this.con.fsm.skipLogin();
            return;
        }
    }

    match = this.con.port.userPrompt.exec(cmd);

    if (match !== null) {
        window.clearTimeout(this.con.userPromptTimeout);
        this.con.fsm.sendUser();
    }
};

CmdSocket.prototype.con.onReceiveInSendingPassword = function(cmd) {
    var match = this.con.port.loginReject.exec(cmd);

    if (match !== null) {
        window.clearTimeout(this.con.loginVerifyTimeout);
        this.con.fsm.rejectLogin();
        return;
    }

    match = this.con.port.loginVerify.exec(cmd);

    if (match !== null) {
        window.clearTimeout(this.con.loginVerifyTimeout);
        this.con.fsm.acceptLogin();
    }
};

CmdSocket.prototype.con.onReceiveInVerifyingConnection = function(cmd) {
    var match;

    if (typeof this.con.port.verifyConnection === 'function') {
        match = this.con.port.verifyConnection(cmd);
    } else {
        match = this.con.port.verifyConnection.exec(cmd);
    }

    if (match !== null) {
        window.clearTimeout(this.con.verifyTimeout);
        this.con.connected = true;
        this.con.doTransitionAfterVerify.call(this);
    } else {
        log.debug(this +
            ': onReceiveInVerifyingConnection: match failed for regex ' +
            this.con.port.verifyConnection.toString());
    }
};

CmdSocket.prototype.con.onRejectLogin = function() {
    log.debug(this + ': onRejectLogin');
    this.con.fsm.tryNextPort();
};

CmdSocket.prototype.con.onSendPassword = function() {
    log.debug(this + ': onSendPassword');

    if (typeof this.con.password === 'undefined' ||
        this.con.password === null) {
        this.con.fsm.tryNextPort();
    } else {
        this.sendCommandInternal(this.con.port.passwordSend(this.con.password));
        this.con.loginVerifyTimeout = window.setTimeout(
            this.con.onLoginVerifyTimeoutExpired.bind(this),
            this.con.port.loginVerifyTimeoutMs);
    }
};

CmdSocket.prototype.con.onSendUser = function() {
    log.debug(this + ': onSendUser');

    if (typeof this.con.user === 'undefined' || this.con.user === null) {
        this.con.fsm.tryNextPort();
    } else {
        this.sendCommandInternal(this.con.port.userSend(this.con.user));

        if (this.con.port.hasOwnProperty('passwordPrompt') &&
            this.con.port.passwordPrompt !== null) {
            this.con.fsm.lookForPasswordPrompt();
        } else if (this.con.port.hasOwnProperty('passwordSend') &&
            this.con.port.passwordSend !== null) {
            this.con.fsm.sendPassword();
        }
    }
};

CmdSocket.prototype.con.onSkipLogin = function() {
    log.debug(this + ': onSkipLogin');
    this.con.fsm.finish();
};

CmdSocket.prototype.con.onTryNextMethod = function() {
    this.con.methodIndex++;

    if (this.con.methodIndex < this.con.methods.length) {
        log.debug(this + ': onTryNextMethod: ' +
            this.con.methods[this.con.methodIndex]);
        this.con.method = this.con.methods[this.con.methodIndex];
        this.con.portIndex = -1;
        this.con.fsm.tryNextPort();
    } else {
        log.debug(this + ': onTryNextMethod: no more methods to try');
        this.con.fsm.fail();
    }
};

CmdSocket.prototype.con.onTryNextPort = function() {
    log.debug(this + ': onTryNextPort');

    this.con.portIndex++;

    if (this.con.portIndex < this.props.ports.length) {
        this.con.port = this.props.ports[this.con.portIndex];

        if (this.con.method === 'auto') {
            var userDefaultExists =
                typeof this.con.port.userDefault !== 'undefined' &&
                this.con.port.userDefault !== null;
            var passwordDefaultExists =
                typeof this.con.port.passwordDefault !== 'undefined' &&
                this.con.port.passwordDefault !== null;

            this.con.user = userDefaultExists ?
                this.con.port.userDefault : this.props.username;
            this.con.password = passwordDefaultExists ?
                this.con.port.passwordDefault : this.props.password;
        } else {
            this.con.user = this.props.username;
            this.con.password = this.props.password;
        }

        this.con.fsm.connectPort();
    } else {
        this.con.fsm.tryNextMethod();
    }
};

CmdSocket.prototype.con.onUserPromptTimeoutExpired = function() {
    log.debug(this + ': onUserPromptTimeoutExpired');
    this.con.fsm.tryNextPort();
};

CmdSocket.prototype.con.onVerifyConnection = function() {
    log.debug(this + ': onVerifyConnection');

    if (this.con.port.hasOwnProperty('verifySend') &&
        this.con.port.verifySend !== null) {
        this.sendCommandInternal(this.con.port.verifySend);
    }

    if (this.con.port.hasOwnProperty('verifyTimeoutMs') &&
        this.con.port.verifyTimeoutMs !== null &&
        this.con.port.verifyTimeoutMs > 0) {
        this.con.verifyTimeout = window.setTimeout(
            this.con.onVerifyTimeoutExpired.bind(this),
            this.con.port.verifyTimeoutMs);
    } else {
        this.con.connected = true;
        this.con.doTransitionAfterVerify.call(this);
    }
};

CmdSocket.prototype.con.onVerifyTimeoutExpired = function() {
    log.debug(this + ': verifyTimeoutExpired');
    this.con.fsm.tryNextPort();
};

// Start the connection process. Results are returned via the onConnectResult
// callback function.

CmdSocket.prototype.connect = function(onConnectResult, onReceiveCommand,
    onConnectionLost, onSendSync) {
    this.client.onConnectResult = onConnectResult;
    this.client.onReceiveCommand = onReceiveCommand;
    this.client.onConnectionLost = onConnectionLost;
    this.client.onSendSync = onSendSync;

    if (this.con.fsm.current !== 'none') {
        log.error(this + ': connect called in fsm state "' +
            this.con.fsm.current + '"');
            this.con.broadcastConnectResult.call(this, {
                state: 'failed',
                connected: false,
                authenticated: false,
            });
        return;
    }

    this.con.fsm.goToStart();
};

// Destroy the CmdSocket.

CmdSocket.prototype.destroy = function() {
    this.closeSocket();

    if (this.syncTimeout !== null) {
        window.clearTimeout(this.syncTimeout);
        this.syncTimeout = null;
    }

    this.con.cleanUp.call(this);
    this.sendQueue.length = 0;
    this.respQueue.length = 0;
    this.cmdBuf.clear();
    this.destroyed = true;
};

// Function for formatting a command to be displayed in the logs.

CmdSocket.prototype.formatCommand = function(cmd) {
    if (cmd === null) return 'null';

    if (typeof cmd !== 'string') {
        return JSON.stringify(cmd, null, 4);
    }

    if (!this.props.isBinary &&
        cmd.charCodeAt(0) >= 32 && cmd.charCodeAt(0) < 127) {
        return cmd;
    }

    var str = '';
    var n;

    if (this.props.isBinary ||
        this.props.negotiateTelnet && cmd[0] === '\xFF' && cmd.length === 3) {
        str += '[';

        for (n = 0; n < cmd.length; n++) {
            if (n !== 0) str += ' ';
            if (cmd.charCodeAt(n) < 16) str += '0';
            str += (cmd.charCodeAt(n) & 0x00ff).toString(16);
        }

        str += ']';
    } else {
        for (n = 0; n < cmd.length; n++) {
            var c = cmd.charCodeAt(n);

            if (c >= 32 && c < 127) {
                str += cmd[n];
            } else {
                str += '<';
                if (c < 16) str += '0';
                str += (c & 0x00ff).toString(16) + '>';
            }
        }
    }

    return str;
};

// Function that tells whether the specified synchronous parameter is in the
// send queue (or response queue if respQueue is true).

CmdSocket.prototype.hasSync = function(param, respQueue) {
    if (typeof respQueue === 'undefined') respQueue = false;

    var i = 0;

    if (!respQueue && this.sendQueue.length !== this.respQueue.length) {
        i = 1;
    }

    for (; i < this.respQueue.length; i++) {
        if (this.respQueue[i] === param) return true;
    }

    return false;
};

// Internal handler for the SocketWrapper's onConnectionLost callback.

CmdSocket.prototype.onConnectionLost = function() {
    log.debug(this + ': connection lost');
    this.destroy();

    if (this.client.onConnectionLost) {
        this.client.onConnectionLost();
    }
};

// Let CmdDevice query whether our buffers are filling up.

CmdSocket.prototype.isFillingUp = function() {
    if (this.sendQueue.length > 7 ||
        this.respQueue.length > 7 ||
        this.cmdBuf.commands.length > 7) {
        log.debug(this + ': isFillingUp: sendQueue.length = ' +
            this.sendQueue.length + ', respQueue.length = ' +
            this.respQueue.length + ', cmdBuf.commands.length = ' +
            this.cmdBuf.commands.length);
        return true;
    }

    return false;
};

CmdSocket.prototype.notifyClientOfSyncSend = function(param) {
    if (this.client.onSendSync) {
        this.client.onSendSync(param);
    }
};

// Internal handler for SocketWrapper's onReceive callback.

CmdSocket.prototype.onReceive = function(data) {
    this.cmdBuf.putUint8Array(data);
    this.processingCommands = true;
    var cmd;

    while (this.cmdBuf.hasTelnetCommands()) {
        cmd = this.cmdBuf.getTelnetCommand();

        driverLog.debug(this + ': received: ' + this.formatCommand(cmd));

        this.processTelnetCommand(cmd);
    }

    while (this.cmdBuf.hasCommands()) {
        cmd = this.cmdBuf.getCommand();

        driverLog.debug(this + ': received: ' + this.formatCommand(cmd));

        if (this.con.fsm.current !== 'finished') {
            this.processConnectionCommand(cmd);
        } else if (this.props.isAsync) {
            this.processAsyncCommand(cmd);
        } else if (this.props.rejectAsync) {
            this.processSyncCommand(cmd);
        } else {
            this.processMixedCommand(cmd);
        }
    }

    this.processingCommands = false;

    if (!this.props.isAsync && this.syncTimeout === null) {
        this.sendNextSyncCommand();
    }

    if (this.con.fsm.current !== 'finished') {
        var match;

        if (this.con.fsm.current === 'lookingForUserPrompt' &&
            this.con.port.hasOwnProperty('userPromptHasNewline') &&
            !this.con.port.userPromptHasNewline) {
            match = this.con.port.userPrompt.exec(this.cmdBuf.command);

            if (match !== null) {
                this.cmdBuf.command.replace(this.con.port.userPrompt, '');
                this.processConnectionCommand(match[0]);
            }
        } else if (this.con.fsm.current === 'lookingForPasswordPrompt' &&
            this.con.port.hasOwnProperty('passwordPromptHasNewline') &&
            !this.con.port.passwordPromptHasNewline) {
            match = this.con.port.passwordPrompt.exec(this.cmdBuf.command);

            if (match !== null) {
                this.cmdBuf.command.replace(this.con.port.passwordPrompt, '');
                this.processConnectionCommand(match[0]);
            }
        }
    }
};

// Internal handler for timeout for susupending synchronous commands.

CmdSocket.prototype.onSuspendSyncTimeout = function() {
    this.suspendSyncTimeout = null;

    if (this.sendQueue.length === this.respQueue.length &&
        this.sendQueue.length > 0) {
        this.sendNextSyncCommand();
    }
};

// Internal handler for synchronous command timeouts.

CmdSocket.prototype.onSyncTimeoutExpired = function() {
    var param = this.respQueue[0];
    this.syncTimeout = null;

    log.warning(this +
        ': did not receive response for last command (param = ' + param + ')');

    if (this.retryCallbacks.hasOwnProperty(param)) {
        if (this.sendRetries >= this.retryCallbacks[param].retryLimit) {
            log.warning(this + ': exceeded retry limit for param');
        } else {
            this.sendRetries++;
            var cmd = this.retryCallbacks[param].callback();

            if (typeof cmd === 'string') {
                log.debug(this + ': retrying ' + param);
                this.sendCommandInternal(cmd, param);
                this.scheduleSyncTimeout(param);
                this.notifyClientOfSyncSend(param);
                return;
            }
        }
    }

    this.respQueue.shift();

    if (this.sendQueue.length > 0) {
        this.sendNextSyncCommand();
    }
};

// Allow drivers to override the sync timeout for a specific command.

CmdSocket.prototype.overrideSyncTimeoutMs = function(param, syncTimeoutMs) {
    this.syncTimeoutMsOverrides[param] = syncTimeoutMs;
};

CmdSocket.prototype.processAsyncCommand = function(cmd) {
        this.client.onReceiveCommand(cmd);
};

CmdSocket.prototype.processConnectionCommand = function(cmd) {
    switch (this.con.fsm.current) {
        case 'verifyingConnection':
            this.con.onReceiveInVerifyingConnection.call(this, cmd);
            break;
        case 'lookingForUserPrompt':
            this.con.onReceiveInLookingForUserPrompt.call(this, cmd);
            break;
        case 'lookingForPasswordPrompt':
            this.con.onReceiveInLookingForPasswordPrompt.call(this, cmd);
            break;
        case 'sendingPassword':
            this.con.onReceiveInSendingPassword.call(this, cmd);
            break;
        default:
            log.warning(this + ': processConnectionCommand: unhandled state = ' +
                this.con.fsm.current);
            break;
    }
};

CmdSocket.prototype.processMixedCommand = function(cmd) {
    var param = this.respQueue.length > 0 ?  this.respQueue[0] : null;

    // The onReceiveCommand callback returns true if the command was
    // successfully matched and handled by the param's handler. If it is, then
    // we can clear the sync timeout and send the next command in the queue. If
    // it isn't, then it was an async command, and we leave the param's async
    // timeout running.

    if (this.client.onReceiveCommand(cmd, param)) {
        window.clearTimeout(this.syncTimeout);
        this.syncTimeout = null;
        this.respQueue.shift();
    }
};

CmdSocket.prototype.processSyncCommand = function(cmd) {
    if (this.respQueue.length <= 0) {
        log.warning(this + ': unexpected response: ' + this.formatCommand(cmd));
        return;
    }

    window.clearTimeout(this.syncTimeout);
    this.syncTimeout = null;

    var param = this.respQueue.shift();
    this.client.onReceiveCommand(cmd, param);
};

CmdSocket.prototype.processTelnetCommand = function(cmd) {
    var option = telnetOptions.hasOwnProperty(cmd.charAt(2)) ?
        telnetOptions[cmd.charAt(2)] : 'unknown';
    option += ' (0x' + cmd.charCodeAt(2).toString(16) + ')';

    switch (cmd.charAt(1)) {
        case '\xFB': // will
            driverLog.debug(this + ': telnet: will ' + option + ' -> responding don\'t');

            this.sendRaw('\xFF\xFE' + cmd.charAt(2));
            break;
        case '\xFC': // won't
            driverLog.debug(this + ': telnet: won\'t ' + option);

            break;
        case '\xFD': // do
            driverLog.debug(this + ': telnet: do ' + option + ' -> responding won\'t');

            this.sendRaw('\xFF\xFC' + cmd.charAt(2));
            break;
        case '\xFE': // don't
            driverLog.debug(this + ': telnet: don\'t ' + option);

            break;
        default:
            log.warning(this + ': unexpected telnet command');
            break;
    }
};

// Function to remove synchronous commands from the queue (as long as they
// haven't been sent yet).

CmdSocket.prototype.removeSync = function(param) {
    var i, p, c;
    var lengthsEqual = this.sendQueue.length === this.respQueue.length;
    var removeIndices = [];

    for (i = 0; i < this.respQueue.length; i++) {
        if (this.respQueue[i] === param) removeIndices.push(i);
    }

    for (i = removeIndices.length - 1; i >= 0; i--) {
        var idx = removeIndices[i];
        if (lengthsEqual) {
            p = this.respQueue.splice(idx, 1)[0];
            c = this.sendQueue.splice(idx, 1)[0];
            driverLog.debug(this + ': removed: ' + p + ' -> ' +
                this.formatCommand(c));
        } else {
            if (i !== 0) {
                p = this.respQueue.splice(idx, 1)[0];
                c = this.sendQueue.splice(idx - 1, 1)[0];
                driverLog.debug(this + ': removed: ' + p + ' -> ' +
                    this.formatCommand(c));
            }
        }
    }
};

// Internal function to schedule sync timeout when sending a sync command.

CmdSocket.prototype.scheduleSyncTimeout = function(param) {
    var syncTimeoutMs = this.props.syncTimeoutMs;

    if (param !== null && this.syncTimeoutMsOverrides.hasOwnProperty(param)) {
        syncTimeoutMs = this.syncTimeoutMsOverrides[param];
    }

    this.syncTimeout = window.setTimeout(
        this.onSyncTimeoutExpired.bind(this), syncTimeoutMs);
};

// Send a command to the device on this socket. If the CmdSocket is configured
// as async, then only the first parameter is required, and it should be the
// command to send. If the CmdSocket is configured as sync, then both parameters
// are required: the first is the param name for the comand, the second is the
// command to send.

CmdSocket.prototype.sendCommand = function(paramOrCmd, cmd, func) {
    if (this.props.isAsync) {
        this.sendCommandInternal(paramOrCmd);
    } else {
        if (typeof cmd === 'undefined') {
            log.error(this + ': send: undefined command for param = ' + paramOrCmd);
        }

        this.respQueue.push(paramOrCmd);

        if (!this.processingCommands && this.respQueue.length === 1 &&
            this.suspendSyncTimeout === null) {
            this.sendCommandInternal(cmd, paramOrCmd, func);

            if (paramOrCmd === null) {
                this.respQueue.shift();
            } else {
                this.scheduleSyncTimeout(paramOrCmd);
                this.notifyClientOfSyncSend(paramOrCmd);
            }
        } else {
            driverLog.debug(this + ': queued: ' + paramOrCmd + ': ' + this.formatCommand(cmd));
            this.sendQueue.push([ cmd, func ]);
        }
    }
};

// Internal function for sending commands.

CmdSocket.prototype.sendCommandInternal = function(cmd, param, func) {
    if (func) { func(); }

    if (param) {
        driverLog.debug(this + ': sent: ' + param + ': ' + this.formatCommand(cmd));
    } else {
        driverLog.debug(this + ': sent: ' + this.formatCommand(cmd));
    }

    if (cmd === null) return;
    this.socket.send(AsciiText.encode(cmd + this.props.sendTerminator));
};

// Internal function to send next synchronous command in the queue.

CmdSocket.prototype.sendNextSyncCommand = function() {
    if (this.suspendSyncTimeout === null && this.sendQueue.length > 0) {
        var param = this.respQueue[0];

        this.sendRetries = 0;
        var q = this.sendQueue.shift();
        this.sendCommandInternal(q[0], param, q[1]);

        if (param === null) {
            this.respQueue.shift();
        } else {
            this.scheduleSyncTimeout(param);
            this.notifyClientOfSyncSend(this.respQueue[0]);
        }

        if (param === null) this.sendNextSyncCommand();
    }
};

CmdSocket.prototype.sendRaw = function(data) {
    driverLog.debug(this + ': sent (raw): ' + this.formatCommand(data));
    this.socket.send(AsciiText.encode(data));
};

// Allow clients to set a callback for sync timeouts. If the callback returns
// a string, it will be sent immediately using the handler for the parameter.

CmdSocket.prototype.setRetryCallback = function(param, callback, retryLimit) {
    if (typeof retryLimit === 'undefined') retryLimit = 5;

    if (callback) {
        this.retryCallbacks[param] = {
            callback: callback,
            retryLimit: retryLimit,
        };
    } else {
        delete this.retryCallbacks[param];
    }
};

// Internal function that suspends outgoing synchronous commands for the
// specified amount of time.

CmdSocket.prototype.suspendSync = function(suspendMs) {
    log.debug(this + ': suspending synchronous commands for ' + suspendMs + ' ms');

    if (this.suspendSyncTimeout !== null) {
        window.clearTimeout(this.suspendSyncTimeout);
    }

    this.suspendSyncTimeout =
        window.setTimeout(this.onSuspendSyncTimeout.bind(this), suspendMs);
};

// Convenience implementation of toString().

CmdSocket.prototype.toString = function() {
    return this.props.name + ' ' + this.props.ipAddress;
};

module.exports = CmdSocket;
